module.exports = __webpack_public_path__ + "static/img/图层 30.ba051146.png";